import { render, staticRenderFns } from "./port.vue?vue&type=template&id=33bb1668&scoped=true&"
import script from "./port.vue?vue&type=script&lang=js&"
export * from "./port.vue?vue&type=script&lang=js&"
import style0 from "./port.vue?vue&type=style&index=0&id=33bb1668&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bb1668",
  null
  
)

export default component.exports